import { useConfig } from '@exam-center/configuration';
import type { ExamCourseType, ExamCourseLanguage } from '@exam-center/graphql';

import { CertificateTemplatePreviewer } from '../../components';
import { getCertificateTemplateImage, type TemplateValue } from '../../utils/certificate-templates';

interface PassCertificateTemplatePreviewerProps {
  examCourseType: ExamCourseType | null | undefined;
  examCourseLanguage: ExamCourseLanguage | null | undefined;
  variant: TemplateValue;
}

export default function PassCertificateTemplatePreviewer(
  props: Readonly<PassCertificateTemplatePreviewerProps>,
) {
  const { examCourseType, examCourseLanguage, variant } = props;

  const { mode } = useConfig();

  if (!examCourseType || !examCourseLanguage) {
    return null;
  }

  const previewSrc = getCertificateTemplateImage(
    'pass',
    examCourseType,
    examCourseLanguage,
    variant,
    mode,
    'preview',
  );

  const fullSrc = getCertificateTemplateImage(
    'pass',
    examCourseType,
    examCourseLanguage,
    variant,
    mode,
    'full',
  );

  return <CertificateTemplatePreviewer previewSrc={previewSrc} fullSrc={fullSrc} />;
}
